export const environment = {
  production: false,
  dev: true,
  local: false,
  baseUrl: "https://dev-potty-notes-api.up.railway.app"
};
